export default "__VITE_ASSET__DWlkzLzH__"